<template>
  <el-dialog fullscreen :visible="isShow" :modal="false" :show-close="false" custom-class="dialog-form">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 数据字典类别表单</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-row class="form-top-btns">
      <el-button v-if="formData.creater_id === operator_id || editable === '是'" type="primary" size="mini" plain round icon="em-icon-save" @click="saveHandler"> 提交保存</el-button>
      <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="close">关闭</el-button>
    </el-row>
    <div class="form-container">
      <el-form ref="form" :model="formData" size="mini" label-width="120px" :show-message="false">
        <!--编辑时主表数据 开始-->
        <div class="form-main">
          <el-row>
            <el-col :span="6">
              <el-form-item label="父级分类">
                <el-tree-select ref="treeSelect" :value="formData.parent_id" :label="parentName" :options="parentCategories" @getValue="getParentValue($event)"></el-tree-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="类别名称" prop="name" required>
                <el-input placeholder="类别名称" clearable v-model="formData.name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="类别编码" prop="name" required>
                <el-input placeholder="类别编码" clearable v-model="formData.code"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="备注">
                <el-input placeholder="备注" clearable v-model="formData.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import ElTreeSelect from '@/components/tree-select/el-tree-select.vue'
export default {
  name: 'EzzDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      // 当前子组件对话框的显隐
      isShow: false,
      // 主表单数据结构
      formData: null,
      formEmptyData: {
        id: '',
        parent_id: '',
        name: '',
        code: '',
        remark: '',
        creater_id: '',
        updater_id: ''
      },
      parentName: '',
      /*
      treeSelectProps: {
        // 配置项（必选）
        value: 'id',
        label: 'name',
        children: 'children'
      },
      */
      // 当前操作者
      operator_id: sessionStorage.getItem('operator_id'),
      parentCategories: [{
        id: '',
        name: '一级类别'
      }],
      editable: this.$store.state.editable
    }
  },
  created: function () {
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
  },
  mounted: function () {
  },
  methods: {
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getDictCategory, { ModelId: _this.formData.id }, function (res) {
        let _json = res.data
        let _formData = _json.category
        let parentId = ''
        if (_formData != null) {
          _this.formData = _formData
          parentId = _this.formData.parent_id
        } else {
          _this.formData = JSON.parse(JSON.stringify(_this.formEmptyData))
          _this.formData.creater_id = _this.operator_id
        }
        _this.parentCategories = [{ id: '', name: '一级类别' }].concat(_json.parentCategories)
        _this.parentName = _json.parentName === '' ? '一级类别' : _json.parentName
        _this.$refs.treeSelect.initHandler(parentId, _this.parentName)
      })
    },
    getParentValue: function (value) {
      this.formData.parent_id = value
    },
    addHandler: function () {
      this.formData.id = '0'
      this.loadData()
      this.isShow = true
    },
    editHandler: function (formId) {
      this.formData.id = formId
      this.loadData()
      this.isShow = true
    },
    validationHandler: function (_formData) {
      let _this = this
      if (_formData !== null) {
        if (_formData.name === '') {
          _this.$message({
            type: 'error',
            message: '类别名称不能为空'
          })
          return false
        }
        if (_formData.code === '') {
          _this.$message({
            type: 'error',
            message: '类别编码不能为空'
          })
          return false
        }
      }
      return true
    },
    // 保存
    saveHandler: function () {
      let _this = this

      if (_this.validationHandler(_this.formData)) {
        _this.formData.operator_id = _this.operator_id
        _this.post(_this.$apis.saveDictCategory, _this.formData, function (res) {
          let _json = res.data
          if (_json.status === 'ok') {
            _this.$message({
              message: '保存成功',
              type: 'success'
            })
            _this.parent.loadData()
            _this.isShow = false
          }
        })
      }
    },
    // 关闭窗口
    close: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isShow = false
        })
        .catch(_ => {
          return false
        })
    }
  },
  components: {
    ElTreeSelect
  }
}
</script>
